import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { CancellationModel } from '../cancellation/cancellation.model';

@Component({
    selector: 'pace-core-base-cancellation',
    imports: [],
    templateUrl: './base-cancellation.component.html',
    styleUrl: './base-cancellation.component.scss',
})
export class BaseCancellationComponent {
    public modalResult: Subject<{
        notificationUpdateKey: string;
    }>;

    @Input()
    public model: CancellationModel;
    @Input()
    public disableModalClose = false;
}
